<template>
    <div class="animated fadeIn">
        <b-card header="Create Tags">
            <div class="add-new-tag-box">
                <input @keyup.enter="clickAddTag" :class="['form-control', 'add-tag-active']" v-model="newTag" type="text" placeholder="Type new tag here" />
                <button class="btn-add-tag action-element" v-on:click="clickAddTag">+ Add new tag</button>
            </div>
            <span class="error-message">{{errorMessage}}</span>
            <h3 class="tags-list-header">Tags list</h3>
            <div class="tags-search-container">
                <div class="tags-search-box">
                    <i class="fa fa-search"></i>
                    <input type="text" placeholder="Search tags" v-model="search.phrase" @keyup="getTagList()" />
                </div>
            </div>
            <div class="tag-list-nav">
                <div class="tag-list-sort">
                    <span class="sort-by">Sort by:</span>
                    <a v-if="(search.sort == 1 && !search.desc) || search.sort == 2" :class="[search.sort == 1 ? 'sorting' : '']" @click="setAlpha">A-Z<i :class="['fa', search.sort == 1 ? 'fa-sort-asc' : 'fa-sort']"></i></a>
                    <a v-if="search.sort == 1 && search.desc" :class="[search.sort == 1 ? 'sorting' : '']" @click="setAlpha">Z-A<i :class="['fa', 'fa-sort-desc']"></i></a>
                    <a v-if="(search.sort == 2 && !search.desc) || search.sort == 1" :class="[search.sort == 2 ? 'sorting' : '']" @click="setMostUsed">Unused<i :class="['fa', search.sort == 2 ? 'fa-sort-desc' : 'fa-sort']"></i></a>
                    <a v-if="search.sort == 2 && search.desc" :class="[search.sort == 2 ? 'sorting' : '']" @click="setMostUsed">Used<i class="fa fa-sort-asc"></i></a>
                </div>
            </div>
            <div class="tag-list">
                <div v-for="tag in tagsList">
                    <div :class="['tag', tag.used ? 'used' : 'unused']">
                        <span class="edit-tag" type="text" v-model="tag.value" :disabled="!tag.edit" :ref="'focus' + tag.id"
                              @keyup.enter="closeTagEdition(tag)"
                              @focusout="closeTagEdition(tag)"
                              @change="changeTag(tag)"
                        >{{tag.value}}</span>
                        <div class="action-icon action-element" @click.stop="showPopup(tag.id)" v-click-outside="hidePopup">
                            <i class="fa fa-ellipsis-v" :tag-value="tag.id"></i>
                            <div :class="['tag-popup', [popupFlag == tag.id ? 'tag-popup-visible' : '']]">
                                <i class="fa fa-pencil" @click="editThisTag(tag)"></i>
                                <i v-if="tag.used" class="fa fa-trash delete-disabled"></i>
                                <i v-else class="fa fa-trash" @click.stop="openDeleteSingleTagModal(tag)"></i>
                            </div>
                        </div>
                        <div v-if="!tag.used" class="used-tooltip">This tag is not used</div>
                    </div>

                </div>
            </div>
        </b-card>


        <b-modal ref="deleteTag" id="deleteTag" :class="['modal-actions-sim']" hide-footer centered>
            <img  src="../../assets/img/unsaved-data.png" alt />

            <h3>Delete Tag</h3>
            <h4>Selected tag will be deleted, are you sure?</h4>
            <div class="button-wrapper">
                <b-button variant="danger" @click="hideDeleteSingleTagModal()">No</b-button>
                <b-button variant="success" @click="deleteSingleTag()">Yes</b-button>
            </div>
        </b-modal>

        <b-modal ref="editTagModal" id="editTagModal" :class="['modal-edit-tag']" hide-footer centered>
            <img  src="../../assets/img/unsaved-data.png" alt />

            <h3>Edit tag</h3>
            <h4>Your change will affect all SIM's which this tag is associated with</h4>
            <input v-model="editedTag.value" type="text" class="form-control edit-tag-input">
            <div class="button-wrapper">
                <b-button variant="light" @click="$refs['editTagModal'].hide()">Cancel</b-button>
                <b-button variant="success" @click="changeTag(editedTag)">Save</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Axios from 'axios'
    import globalStore from "../../variables";

    export default {
        name: "Tags",
        data() {
            return {
                newTag: null,
                errorMessage: '',
                tagsList: [],
                popupFlag: 0,
                editTag: {
                    id: '',
                    edition: false
                },
                removeList: [],
                singleTag: null,
                search: {
                    sort: 1,
                    desc: false,
                    phrase: ''
                },
                editedTag: {}
            }
        },
        methods: {
            clickAddTag () {

                if (this.newTag.length > 0) {

                    let alreadyAdded = this.tagsList.filter(tag => {
                        return tag.value == this.newTag
                    });
                    if (alreadyAdded.length == 0) {
                        this.addTag(this.newTag);
                        this.newTag = null;
                        this.errorMessage = null;
                        this.getTagList();
                    } else {
                        this.errorMessage = 'This tag is already on the list.';
                    }
                }
            },
            showPopup (tag) {
                if (this.popupFlag != tag) {
                    this.popupFlag = tag;
                } else {
                    this.popupFlag = 0;
                }
            },
            hidePopup() {
                this.popupFlag = 0;
            },
            editThisTag(tag) {
                this.editedTag = {
                    value: tag.value,
                    id: tag.id
                    };
                this.$refs['editTagModal'].show();
            },
            closeTagEdition(tag) {
                tag.edit = false;
            },
            openDeleteSingleTagModal(tag) {
                this.singleTag = tag;
                this.$refs['deleteTag'].show();
            },
            hideDeleteSingleTagModal() {
                this.$refs['deleteTag'].hide();
                this.singleTag = null;
            },
            deleteSingleTag() {
                this.deleteTag(this.singleTag);
                this.singleTag = null;
                this.$refs['deleteTag'].hide();
            },
            getTagList() {
                if (this.search.phrase == '') {

                    Axios.get(globalStore.data.restApiUrl + "/tags?sort=" + this.search.sort + "&desc=" + this.search.desc)
                        .then(response => {
                            this.tagsList = [];
                            response.data.map(tag => {
                                this.tagsList.push(
                                    {
                                        id: tag.id,
                                        value: tag.label,
                                        edit: false,
                                        used: tag.isUsed
                                    }
                                )
                            })
                        })
                } else {
                    Axios.get(globalStore.data.restApiUrl + "/tags?sort=" + this.search.sort + "&desc=" + this.search.desc + "&search=" + escape(this.search.phrase))
                        .then(response => {
                            this.tagsList = [];
                            response.data.map(tag => {
                                this.tagsList.push(
                                    {
                                        id: tag.id,
                                        value: tag.label,
                                        edit: false,
                                        used: tag.isUsed
                                    }
                                )
                            })
                        })
                }
            },
            addTag(tag){
                Axios.put(globalStore.data.restApiUrl + "/tags", {newLabel: tag})
                    .then(response => {
                        if (response.status == 201) {
                            this.getTagList();
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                text: 'Tag "' + tag + '" created',
                                duration: 5000,
                            });
                        }
                    })
            },
            deleteTag(tag) {
                Axios.delete(globalStore.data.restApiUrl + "/tags/" + tag.id)
                    .then(() => {
                        for (let i = 0 ; i < this.removeList.length ; i++) {
                            if (this.removeList[i].id == tag.id) {
                                this.removeList.splice(i,1);
                            }
                        }
                        if (!this.bulkRemoveFlag){
                            this.getTagList();
                        }
                    })
                .catch(error => {
                    console.log(error.response)
                    if (error.response.status == 400 && error.response.data == 'Tag is used, and cannot be deleted.') {
                        this.$refs['cannotDeleteTag'].show();
                    } else {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Tag not deleted',
                            text: 'Unknown error has occured during deleting tag. Please contact support.',
                            duration: 5000,
                        });
                    }
                })
            },
            changeTag(tag){
                Axios.patch(globalStore.data.restApiUrl + "/tags/" + tag.id, {newLabel: tag.value})
                    .then(response => {
                        this.hidePopup();
                        let index = this.removeList.indexOf(tag);
                        this.removeList.splice(index, 1);
                        tag.selected = false;
                        this.$refs['editTagModal'].hide();
                        this.getTagList();
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Tag saved',
                            text: 'Your tag has been successfully edited.',
                            duration: 5000,
                        });
                    })
                .catch(error => {
                  if (error.response.data.errors[0].errorMessage == 'There already exists tag with passed name!' ) {
                    this.$notify({
                      type: 'error',
                      group: 'notification',
                      title: 'Tag name already in use',
                      text: 'Tag with passed name already exists for this company',
                      duration: 5000
                    })
                  }  else {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Tag not saved.',
                        text: 'Something was wrong during saving new tag value. Please contact support..',
                        duration: 5000,
                    });
                }
                })
            },
            setMostUsed(){
                if (this.search.sort == 2){
                    this.search.desc = !this.search.desc;
                } else {
                    this.search.sort = 2;
                    this.search.desc = false;
                }
                this.getTagList();
            },
            setAlpha(){
                if (this.search.sort == 1) {
                    this.search.desc = !this.search.desc;
                } else {
                    this.search.sort = 1;
                    this.search.desc = false;
                }
                this.getTagList();
            },
            setTagInputWidth(tag) {
                return ('width: ' + (tag.value.length * 8 + 1) + 'px')
            }
        },
        mounted() {
            this.getTagList();
            //this.assign();

        }
    }
    Vue.directive('click-outside', {
        bind: function (el, binding, vnode) {
            el.clickOutsideEvent = function (event) {
                if (!(el == event.target || el.contains(event.target))) {
                    vnode.context[binding.expression](event);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: function (el) {
            document.body.removeEventListener('click', el.clickOutsideEvent)
        },
    });
</script>

<style lang="scss">

    .add-new-tag-box {
        display: flex;
        max-width: 100%;
        margin-right: 10px;

        .add-tag-active {
            max-width: 250px;
            margin-right: -30px;
            -webkit-border-radius: 20px;
            -moz-border-radius: 20px;
            border-radius: 20px;
            &:focus {
                outline: none;
            }
        }
        .btn-add-tag {
            min-width: 120px;
            height: 35px;
            background-color: #0088ff;
            color: #fff;
            -webkit-border-radius: 20px;
            -moz-border-radius: 20px;
            border-radius: 20px;
            border: 0;
            outline: none;
        }
    }

    .tags-list-header {
        font-size: 14px;
        margin: 0 -20px;
        padding: 20px;
        background-color: #f8f8f8;
        font-weight: 700;
    }

    .tags-search-container {
        margin: 0 -20px;
        padding: 0 20px;
        background-color: #f8f8f8;

        .tags-search-box {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            width: 240px;
            background-color: #f0f3f5;
            border: 1px solid #c9cfd4;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            padding: 0 10px;
            color: #727A82;

            input {
                padding: 6px;
                width: 70%;
                border: none;
                background-color: #f0f3f5;
                color: #727A82;
                &:focus {
                    outline: 0;
                }
            }
        }
    }

    .error-message {
        display: block;
        height: 20px;
        margin: 2px 0 2px 15px;
    }

    .tag-list {
        display: flex;
        flex-wrap: wrap;
        padding: 20px;
        margin: 0 -20px -20px;
        background-color: #f8f8f8;

        .tag {
            position: relative;
            display: flex;
            align-items: center;
            padding: 6px 15px 6px 10px;
            margin-right: 8px;
            margin-bottom: 10px;
            border: 1px solid #c9cfd4;
            -webkit-border-radius: 20px;
            -moz-border-radius: 20px;
            border-radius: 20px;
            cursor: pointer;

            &.used {
                background-color: #fff;
            }

            &.unused {
                background-color: #ececec;
            }

            .used-tooltip {
                position: absolute;
                display: none;
                bottom: 120%;
                background-color: #241717;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                color: #ffffff;
                padding: 8px 16px;
                white-space: nowrap;
            }

            .edit-tag {
                width: fit-content;
                border: none;
                &:focus {
                    outline: none;
                }
                &:disabled {
                    background-color: #fff;
                }
            }

            &:hover {
                border-color: #0088ff;
                .used-tooltip {
                    display: initial;
                }
            }

            &[is-selected="true"] {
                border-color: #0088ff;
                background-color: #0074d9;
                span {
                    background-color: #0074d9;
                    color: #ffffff;
                }
                i {
                    &:before {
                        color: #ffffff;
                    }
                }
                .tag-popup-visible {
                    i {
                        &:before {
                            color: #000000;
                        }
                    }
                }
            }

            .tag-value {
                margin-right: 10px;
            }

            .action-icon {
                width: 20px;
                margin-left: 10px;
                text-align: center;
                cursor: pointer;
            }


        }
    }

    .tag-popup {
        visibility: hidden;
        position: absolute;
        bottom: -14px;
        right: -45px;
        background-color: #ffffff;
        border: 1px solid #c8ced3;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        z-index: 5;
        i {
            display: block;
            padding: 10px;
            &:hover {
                background-color: #f0f3f5;
            }
            &.fa-pencil {
                border-bottom: 1px solid #c8ced3;

                &:after {
                    content: 'Edit';
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
                    margin-left: 11px;
                }
            }
            &.fa-trash {
                &:after {
                    content: 'Delete';
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
                    margin-left: 11px;
                }
                &.delete-disabled {
                    &::before,
                    &::after {
                        color: #979a9c;
                    }
                }
            }
        }
    }

    .tag-popup-visible {
        visibility: visible;
    }

    .tag-list-nav {
        display: flex;
        justify-content: space-between;
        background-color: #f8f8f8;
        margin: 0 -20px 0;
        padding: 20px 40px 20px 20px;
        .tag-list-sort {
            .sort-by {
                margin-right: 8px;
            }
            a {
                margin-right: 20px;

                &.sort-asc {
                    &::after {
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10.002' viewBox='0 0 6 10.002'%3E%3Cg id='Group_21113' data-name='Group 21113' transform='translate(-843 -194)'%3E%3Cpath id='Path_13278' data-name='Path 13278' d='M5.6,9.766l-3-4h6Z' transform='translate(851.6 203.767) rotate(180)' fill='%2308f'/%3E%3Cpath id='Path_13396' data-name='Path 13396' d='M3,4,0,0H6Z' transform='translate(843 200.003)' fill='%23515b65'/%3E%3C/g%3E%3C/svg%3E%0A");
                    }
                }

                &.sort-desc {
                    &::after {
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10.002' viewBox='0 0 6 10.002'%3E%3Cg id='Group_21114' data-name='Group 21114' transform='translate(-860 -194.001)'%3E%3Cpath id='Path_13278' data-name='Path 13278' d='M5.6,9.766l-3-4h6Z' transform='translate(857.4 194.237)' fill='%2308f'/%3E%3Cpath id='Path_13396' data-name='Path 13396' d='M3,4,0,0H6Z' transform='translate(866 198.001) rotate(180)' fill='%23515b65'/%3E%3C/g%3E%3C/svg%3E%0A");
                    }
                }

                i {
                    margin-left: 8px;
                    color: #0088FF;
                }
                cursor: pointer;
                &.sorting {
                    font-weight: 700;
                }
            }
        }
        .tag-list-remove {
            position: relative;
            .remove-selected-btn {
                color: #cfd1d2;
                font-weight: 500;
                cursor: pointer;
                &.red {
                    color: #FC4D4D;
                }
            }
            .used-tooltip {
                display: none;
                position: absolute;
                bottom: 100%;
                right: 10px;
                padding: 7px 12px;
                background-color: #241717;
                color: #fff;
                white-space: nowrap;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                font-size: 14px;
            }
            &:hover {
                .used-tooltip {
                    display: block;
                }
            }
        }
    }

    #deleteTag___BV_modal_content_ {
        .modal-header {
            padding-bottom: 0;
        }

        .modal-body {
            text-align: center;

            i {
                color: #0088FF;
                margin-bottom: 15px;
            }

            img {
                width: auto;
                height: 19px;
                margin-bottom: 15px;
            }

            h3 {
                display: block;
                margin-bottom: 18px;
                font-size: 15px;
                line-height: 18px;
                font-weight: 700;
                color: #2F353A;
            }

            h4 {
                display: block;
                margin-bottom: 40px;
                font-size: 14px;
                line-height: 24px;
                color: #515B65;
            }

            .button-wrapper {
                button {
                    margin: 0 5px;
                    padding-left: 15px;
                    padding-right: 15px;
                }
            }
        }
    }

    #editTagModal___BV_modal_content_ {
        .modal-header {
            padding-bottom: 0;
        }

        .modal-body {
            padding-top: 0;
            text-align: center;

            i {
                color: #0088FF;
                margin-bottom: 15px;
            }

            img {
                width: auto;
                height: 19px;
                margin-bottom: 15px;
            }

            h3 {
                display: block;
                margin-bottom: 18px;
                font-size: 15px;
                line-height: 18px;
                font-weight: 700;
                color: #2F353A;
            }

            h4 {
                display: block;
                margin-bottom: 20px;
                font-size: 14px;
                line-height: 24px;
                color: #515B65;
            }

            .edit-tag-input {
                max-width: 80%;
                margin: 0 auto 20px;
            }

            .button-wrapper {
                button {
                    margin: 0 5px;
                    padding-left: 15px;
                    padding-right: 15px;
                }
            }
        }
    }

    .dark-theme {
        .tags-search-box {
            background-color: #515b65;
            border: 1px solid #1a1c1d;
            color: #EDEEEF;

            input,
            i,
            input::placeholder {
                background-color: #515b65;
                color: #EDEEEF;
            }
        }

        .tags-list-header,
        .tags-search-container {
            background-color: #3a4149;
        }

        .tag-list-nav,
        .tag-list {
            background-color: #3a4149;
            .tag {

                &.used {
                    background-color: #2F353A;
                    border-color: #1A1C1D;
                }

                &.unused {
                    background-color: #515b65;
                    border-color: #515b65;
                }

                &:hover {
                    border-color: #0088ff;
                }

                &[is-selected="true"] {
                    border-color: #0088ff;
                    background-color: #0074d9;
                }

                .edit-tag {
                    background-color: transparent;
                    color: #EDEEEF;
                }
                .tag-popup {
                    background-color: #3a4149;
                    color: #EDEEEF;
                    border-color: #1a1c1d;

                    i {
                        border-color: #1a1c1d;
                    }

                    i:hover {
                        background-color: #2f353a;
                    }
                }
            }
        }

        #deleteTag___BV_modal_content_ {
            background-color: #3a4149;
            .close,
            h3,
            h4 {
                color: #ffffff;
            }

            #deleteTag___BV_modal_header_ {
                button {
                    color: #ffffff;
                }
            }
        }

        #editTagModal___BV_modal_content_ {
            background-color: #3a4149;
            h3,
            h4 {
                color: #ffffff;
            }

            input {
                border-color: #1a1c1d;
                background-color: #515b65;
                color: #ffffff;
            }
        }
    }

    @media screen and (max-width: 991px) {
        #editTagModal___BV_modal_content_,
        #deleteTag___BV_modal_content_ {
            .modal-body {
                background-color: #fff;
            }
        }
    }

</style>
